<template>
  <div class="tp-cta" v-if="isBannerActive()">
    <div class="tp-cta__image">
      <img :src="getImage()" alt="Oferty wczasów na Travelplanet.pl" />
    </div>
    <div class="tp-cta__content">
      <a
        class="tp-cta__content-link"
        :href="getTpLink()"
        :title="getTitleText()"
        rel="noopener"
        target="_blank"
      >
        <span class="tp-cta__text" v-html="getTpFrontUp()"></span>
        <span class="btn btn-lg btn-orange">{{ getTpFrontDown() }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import * as CONFIG from "../config.js";
import * as TPBANNER from "../travelplanetbanner.js";

export default {
  name: "travelplanet-cta",
  props: {
    isSkione: Boolean,
  },
  data: () => ({
    imagePath: "/img/static/",
    title: "Travelplanet Banner",
    bezbannera:
      "rumunia,jordania,stanyzjednoczone,emiratyarabskie,slowacja,slowenia,austria,izrael,rpa,czechy,maroko,srilanka,francja,belgia,australia,argentyna,wenezuela,polinezja,nowazelandia,malezja,hawaje,chiny",
  }),
  methods: {
    isBannerActive() {
      return this.bezbannera.indexOf(CONFIG.panstwo_id) === -1;
    },
    getTpLink() {
      return TPBANNER.tplink;
    },
    getTpFrontUp() {
      return TPBANNER.tpfrontup;
    },
    getTpFrontDown() {
      return TPBANNER.tpfrontdown;
    },
    getTitleText() {
      let textUp = this.getTpFrontUp().replace(/<[^>]*>/g, "");
      return textUp + " - " + this.getTpFrontDown();
    },
    getImage() {
      let imageName = "tp-cta";

      if (!this.isSkione) {
        return this.imagePath + imageName + ".jpg";
      } else {
        return this.imagePath + imageName + "-winter.jpg";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tp-cta {
  margin-bottom: 64px;
  position: relative;

  @media (max-width: $screen-xxxs-max) {
    margin-left: -16px;
    margin-right: -16px;
  }

  @media (min-width: $screen-sm) {
    display: flex;
    margin-bottom: 92px;
    width: 100%;
    height: 180px;
  }

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 160px;

    @media (max-width: $screen-xs-max) and (min-width: $screen-xxs) {
      height: 220px;
      justify-content: flex-end;
    }

    @media (min-width: $screen-xxs) {
      border-radius: 3px;
    }

    @media (min-width: $screen-sm) {
      border-radius: 3px 0 0 3px;
      height: 100%;
      flex: 1 1 100%;
      max-width: 45%;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;

      @media (max-width: $screen-xs-max) and (min-width: $screen-xxs) {
        width: 180vw;
        height: 100%;
        right: 0;
      }
    }
  }

  &__content {
    display: flex;
    height: 100%;
    flex: 1 1 100%;
    padding: 24px 16px 0;

    @media (max-width: $screen-xs-max) and (min-width: $screen-xxs) {
      padding: 16px;
      position: absolute;
      width: 65%;
      top: 0;
      right: 0;
    }

    @media (min-width: $screen-sm) {
      border-color: $border-color;
      border-radius: 0 3px 3px 0;
      border-style: solid;
      border-width: 1px 1px 1px 0;
      padding: 16px;
    }
  }

  &__content-link {
    color: $text-color-default;
    margin: auto;
    text-align: center;
    text-decoration: none;
  }

  &__text {
    @include font-m();
    display: block;
    font-size: 24px;
    line-height: 1.25;
    margin-bottom: 24px;
    margin-top: -6px;

    @media (min-width: $screen-xxs) {
      font-size: 26px;
    }

    ::v-deep span {
      @include font-b();
      color: $orange-default;
    }
  }
}
</style>
